import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import ApiService from '../../ApiService';
import DispatchProps from '../../../utils/DispatchProps';
import { IRootState } from '../../../store';
import { AssignmentFetchStatus } from '../../../models/analytics/AssignmentFetchStatus';
import { FRIENDLY_DATE_FORMAT } from '../../../utils/Utils';
import moment from "moment";
import { DirectionalHint, TooltipHost } from 'office-ui-fabric-react';

interface SchoolAssignmentFetchStatusProps {
    tenantId: string,
    schoolCode: string,
    academicYear: number,

    apiService: ApiService
}

interface SchoolAssignmentFetchStatusState {
    loading: boolean
    assignmentFetchStatus?: AssignmentFetchStatus
}

class SchoolAssignmentFetchStatus extends Component<SchoolAssignmentFetchStatusProps & DispatchProps, SchoolAssignmentFetchStatusState> {
    static displayName = SchoolAssignmentFetchStatus.name;

    constructor(props: SchoolAssignmentFetchStatusProps & DispatchProps) {
        super(props);
        this.state = {
            loading: false
        }
    }

    async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode && this.props.academicYear) {
            await this.loadFetchStatus();
        }
    }

    async componentDidUpdate(prevProps: Readonly<SchoolAssignmentFetchStatusProps & DispatchProps>, prevState: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode || this.props.academicYear !== prevProps.academicYear) {
            await this.loadFetchStatus();
        }
    }

    private async loadFetchStatus() {
        this.setState({
            loading: true
        });

        let response = await this.props.apiService.getSchoolAssignmentFetchStatus(this.props.tenantId, this.props.schoolCode, this.props.academicYear);


        this.setState({
            loading: false,
            assignmentFetchStatus: response
        });
    }

    static tooltipMessage = <Fragment>
        <div className="fetch-status-tool-tip">
            Assignments and submissions can take up to <strong>2 weeks</strong> to appear after the assignment <strong>due date</strong>.
        </div>
        <div className="fetch-status-tool-tip">
            This is to ensure late submissions are recorded accurately.
        </div>
    </Fragment>

    private getStatusMessage() {
        if (this.state.loading) {
            return "Loading..."
        }

        if (this.state.assignmentFetchStatus == null) {
            return "No data for this academic year"
        }

        let date = moment(this.state.assignmentFetchStatus.submissionsLastFetchedAt).format(FRIENDLY_DATE_FORMAT);

        return <Fragment>
            <span>Last updated on <strong>{date}</strong> </span>

            <TooltipHost
                content={SchoolAssignmentFetchStatus.tooltipMessage}
                closeDelay={500}
                calloutProps={{ gapSpace: 0, directionalHint: DirectionalHint.bottomRightEdge }}
                styles={{ root: { display: 'inline-block' } }}>
                <span className="learn-more">Learn more</span>
            </TooltipHost>
        </Fragment>
    }

    render() {
        return (
            <div className="analytics-control-bar__assignment-fetch-status">
                {this.getStatusMessage()}
            </div>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): SchoolAssignmentFetchStatusProps => {
        return {
            apiService: state.auth.apiService,
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            academicYear: ownProps.academicYear,
        };
    }
)(SchoolAssignmentFetchStatus)
